import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { getAllPartnersList } from '../../../../../../../../redux/fetchActions/legadoPage/clientsApp';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 16rem;
`;

const Label = styled.label`
  font-size: ${(props) => props.theme.fontSize.small};
  color: ${(props) => props.theme.colors.lightGray};
  font-weight: 600;
  margin: 0;
`;

const FixedPartner = styled.div`
  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.gray};
  font-size: ${(props) => props.theme.fontSize.medium};
  font-weight: 600;
  padding: 0.5rem 0.75rem;
  border-radius: ${(props) => props.theme.border.default};
  border: 1px dashed ${(props) => props.theme.colors.lightGray};
`;

interface Partner {
  id: number;
  // eslint-disable-next-line camelcase
  razao_social: string;
}

interface Props {
  value: number | null;
  // eslint-disable-next-line no-unused-vars
  onChange: (partnerId: number, partnerName: string) => void;
}

function PartnerSelect({ value, onChange }: Props) {
  const dispatch = useDispatch();
  const userProfile = useSelector((reducer: IReducer) => reducer.userProfile);
  const partnerProfile = useSelector(
    (reducer: IReducer) => reducer.partnerProfile
  );
  const partnersList: Partner[] = useSelector(
    (reducer: IReducer) => reducer.clientsApp.partnersList
  );

  // Select e lista de parceiros aparecem APENAS pra admin Fiducia
  // (nivel === 2 E partnerId === 1). Pra qualquer outro caso o componente
  // nao renderiza o <select>, eliminando o vetor de manipulacao via DOM
  // (DevTools) — o parceiro fica fixado no parceiro do usuario logado.
  const isAdminFiducia = userProfile.nivel === 2 && userProfile.partnerId === 1;

  // Carrega lista de parceiros so quando o usuario tem permissao.
  // Evita request desnecessario e tambem evita popular o Redux com dados
  // que outros pontos do app poderiam expor pra usuarios sem permissao.
  useEffect(() => {
    if (isAdminFiducia && (!partnersList || partnersList.length === 0)) {
      dispatch(getAllPartnersList());
    }
  }, [dispatch, isAdminFiducia, partnersList]);

  // Pra nao-admin-Fiducia: forca o parceiro do usuario no form sem permitir
  // override. Mesmo se algum estado anterior tiver setado outro valor.
  useEffect(() => {
    if (
      !isAdminFiducia &&
      partnerProfile.idLegado &&
      value !== partnerProfile.idLegado
    ) {
      onChange(
        partnerProfile.idLegado,
        partnerProfile.companyName || 'Meu parceiro'
      );
    }
  }, [isAdminFiducia, partnerProfile.idLegado]);

  function handleChange(event: React.ChangeEvent<HTMLSelectElement>) {
    const id = Number(event.target.value);
    if (!id) {
      onChange(0, '');
      return;
    }
    const found = partnersList.find((p) => p.id === id);
    onChange(id, found ? found.razao_social : '');
  }

  if (!isAdminFiducia) {
    return (
      <Wrapper>
        <Label>Parceiro</Label>
        <FixedPartner>
          {partnerProfile.companyName || 'Carregando…'}
        </FixedPartner>
      </Wrapper>
    );
  }

  const sortedPartners = [...(partnersList || [])].sort((a, b) =>
    a.id > b.id ? 1 : -1
  );

  return (
    <Wrapper>
      <Label>Parceiro</Label>
      <Form.Control as="select" value={value ?? ''} onChange={handleChange}>
        <option value="">Selecione um parceiro</option>
        {sortedPartners.map((partner) => (
          <option key={partner.id} value={partner.id}>
            {partner.id} - {partner.razao_social}
          </option>
        ))}
      </Form.Control>
    </Wrapper>
  );
}

export default PartnerSelect;
